import { SignalTypeMeta } from "@megaron/resource";

import { BudgetDoc } from "./budget";
import { InvoiceDraftDoc } from "./draftDoc";
import { InvoiceThreadDoc } from "./threadDoc";

type InvoicesDocType = (InvoiceThreadDoc | InvoiceDraftDoc | BudgetDoc)["docType"];

export const invoicesSignalTypes = {
  unreadInvoice: {
    subjectDocType: "invoice-thread",
    level: "warning",
    app: "invoices",
    actionLabel: "Nieprzeczytana faktura",
  },
  invoiceThreadMention: {
    subjectDocType: "invoice-thread",
    level: "info",
    app: "invoices",
    actionLabel: "Oznaczenie w komentarzu wątku faktury",
  },
  draftInvoice: {
    subjectDocType: "invoice-draft",
    level: "info",
    app: "invoices",
    actionLabel: "Wersja robocza do dokończenia",
  },
} as const satisfies Record<string, SignalTypeMeta<InvoicesDocType>>;
